import React  from "react";
import { useParams } from 'react-router-dom';
import TrainingClassParticipantForm from "./components/TrainingClassParticipantForm";
import Card from "components/card";

const EditTrainingClassParticipant = () => {

	const { classeId } = useParams();

	return (
	    <div>
	    	<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
      				<TrainingClassParticipantForm classeId={classeId} mode="edit"/>
	      		</div>
	    	</Card>
	    </div>
    );
};

export default EditTrainingClassParticipant;